import { useEffect } from 'react';
import MarketingNav from '../components/MarketingNav';
import StatuteRouteSEO from '../components/StatuteRouteSEO';
import Library from './Library';
import { useAuth } from '../contexts/AuthContext';
import { appUrl } from '../lib/domains';

export default function PublicStatute() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const libPath = window.location.pathname.replace(/^\/statutes/, '/library');
    window.location.replace(
      appUrl(libPath, window.location.search, window.location.hash),
    );
  }, [user]);

  return (
    <div className="h-screen bg-[#fafafa] text-zinc-900 overflow-hidden">
      <StatuteRouteSEO />
      <MarketingNav />
      <div className="pt-16 h-full">
        <div className="relative h-[calc(100vh-4rem)]">
          <Library isPublic basePath="/statutes" />
        </div>
      </div>
    </div>
  );
}
